/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import React from "react";

export const HeroiconsMiniEnvelopeOpen = ({ className }) => {
  return (
    <svg
      className={`heroicons-mini-envelope-open ${className}`}
      fill="none"
      height="20"
      viewBox="0 0 20 20"
      width="20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className="path"
        clipRule="evenodd"
        d="M2.10557 6.44721C1.428 6.786 1 7.47852 1 8.23607V16C1 17.1046 1.89543 18 3 18H17C18.1046 18 19 17.1046 19 16V8.23607C19 7.47852 18.572 6.786 17.8944 6.44722L10.8944 2.94721C10.3314 2.66569 9.66863 2.66569 9.10557 2.94721L2.10557 6.44721ZM3.58541 10.4542C3.21493 10.2689 2.76442 10.4191 2.57918 10.7896C2.39394 11.1601 2.54411 11.6106 2.91459 11.7958L8.77016 14.7236C9.54436 15.1107 10.4556 15.1107 11.2298 14.7236L17.0823 11.7974C17.4528 11.6121 17.6029 11.1616 17.4177 10.7912C17.2325 10.4207 16.7819 10.2705 16.4115 10.4557L10.559 13.382C10.2071 13.5579 9.79289 13.5579 9.44098 13.382L3.58541 10.4542Z"
        fill="#7041F1"
        fillRule="evenodd"
      />
    </svg>
  );
};
